import { render, staticRenderFns } from "./ddskdzd.vue?vue&type=template&id=3220fe16&scoped=true&"
import script from "./ddskdzd.vue?vue&type=script&lang=js&"
export * from "./ddskdzd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220fe16",
  null
  
)

export default component.exports